import { Actor, SlidingState } from "../actor.js";
import { Layer } from "../tile.js";
import { actorDB, getTagFlag } from "../const.js";
import { Wall } from "./walls.js";
import { Playable } from "./playables.js";
import { onLevelDecisionTick, onLevelWireTick, } from "../level.js";
import { Direction, hasOwnProperty } from "../helpers.js";
import { dirToWire, WireOverlapMode, Wires, wireToDir, } from "../wires.js";
import { doBlueTeleport } from "./teleport.js";
export class LetterTile extends Actor {
    constructor() {
        super(...arguments);
        this.id = "letterTile";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
}
actorDB["letterTile"] = LetterTile;
export class CustomFloor extends Actor {
    constructor() {
        super(...arguments);
        this.id = "customFloor";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
}
CustomFloor.tags = ["blocks-ghost"];
actorDB["customFloor"] = CustomFloor;
export class Ice extends Actor {
    constructor() {
        super(...arguments);
        this.id = "ice";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorJoined(other) {
        other.slidingState = SlidingState.STRONG;
    }
    actorCompletelyJoinedIgnored(other) {
        var _a;
        if (other.hasTag("real-playable")) {
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("slide step");
        }
    }
    actorLeft(other) {
        var _a;
        if (other.hasTag("real-playable")) {
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playContinuous("ice slide");
        }
    }
    actorCompletelyLeft(other) {
        var _a;
        if (other.hasTag("real-playable")) {
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.stopContinuous("ice slide");
        }
    }
    actorOnTile(other) {
        if (other._internalIgnores(this))
            return;
        if (!other.bonked)
            return;
        other.slidingState = SlidingState.STRONG;
        if (other.hasTag("super-weirdly-ignores-ice"))
            return;
        // Turn the other way
        other.direction += 2;
        other.direction %= 4;
        if (other._internalStep(other.direction))
            other.cooldown--;
    }
    speedMod(other) {
        if (other.hasTag("weirdly-ignores-ice"))
            return 1;
        return 2;
    }
}
Ice.tags = ["ice"];
actorDB["ice"] = Ice;
export class IceCorner extends Actor {
    constructor() {
        super(...arguments);
        this.id = "iceCorner";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorJoined(other) {
        other.slidingState = SlidingState.STRONG;
    }
    actorCompletelyJoinedIgnored(other) {
        var _a;
        if (other.hasTag("real-playable")) {
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("slide step");
        }
    }
    actorLeft(other) {
        var _a;
        if (other.hasTag("real-playable")) {
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playContinuous("ice slide");
        }
    }
    actorCompletelyLeft(other) {
        var _a;
        if (other.hasTag("real-playable")) {
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.stopContinuous("ice slide");
        }
    }
    actorOnTile(other) {
        if (other._internalIgnores(this))
            return;
        if (other.hasTag("super-weirdly-ignores-ice"))
            return;
        if (other.bonked)
            other.direction += 2;
        if (!other.hasTag("weirdly-ignores-ice")) {
            other.direction += (this.direction - other.direction) * 2 - 1 + 8;
        }
        other.direction %= 4;
        if (other.bonked && other._internalStep(other.direction))
            other.cooldown--;
    }
    speedMod(other) {
        if (other.hasTag("weirdly-ignores-ice"))
            return 1;
        return 2;
    }
    blocks(_other, otherMoveDirection) {
        return !(otherMoveDirection === this.direction ||
            otherMoveDirection === (this.direction + 1) % 4);
    }
    exitBlocks(other, otherMoveDirection) {
        if (other.hasTag("weirdly-ignores-ice"))
            return false;
        return (otherMoveDirection === this.direction ||
            otherMoveDirection === (this.direction + 1) % 4);
    }
}
IceCorner.tags = ["ice"];
actorDB["iceCorner"] = IceCorner;
export class ForceFloor extends Actor {
    constructor() {
        super(...arguments);
        this.id = "forceFloor";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorJoined(other) {
        var _a;
        if (other.hasTag("real-playable")) {
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playContinuous("force floor");
        }
        if (other.hasTag("block"))
            other.slidingState = SlidingState.WEAK;
    }
    actorCompletelyJoinedIgnored(other) {
        var _a;
        if (other.hasTag("real-playable")) {
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("slide step");
        }
    }
    actorLeft(other) {
        var _a;
        if (other.hasTag("real-playable")) {
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.stopContinuous("force floor");
        }
    }
    actorOnTile(other) {
        if (other.layer !== Layer.MOVABLE)
            return;
        if (other.bonked)
            other.enterTile(true);
        if (!other._internalIgnores(this)) {
            other.slidingState = SlidingState.WEAK;
            other.direction = this.direction;
            if (other.bonked) {
                if (other._internalStep(other.direction))
                    other.cooldown--;
            }
        }
    }
    speedMod() {
        return 2;
    }
    pulse() {
        this.direction += 2;
        this.direction %= 4;
    }
}
ForceFloor.tags = ["force-floor"];
actorDB["forceFloor"] = ForceFloor;
export class ForceFloorRandom extends Actor {
    constructor() {
        super(...arguments);
        this.id = "forceFloorRandom";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorJoined(other) {
        var _a;
        if (other.hasTag("real-playable")) {
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playContinuous("force floor");
        }
        if (other.hasTag("block"))
            other.slidingState = SlidingState.WEAK;
    }
    actorCompletelyJoinedIgnored(other) {
        var _a;
        if (other.hasTag("real-playable")) {
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("slide step");
        }
    }
    actorLeft(other) {
        var _a;
        if (other.hasTag("real-playable")) {
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.stopContinuous("force floor");
        }
    }
    actorOnTile(other) {
        if (other.layer !== Layer.MOVABLE)
            return;
        if (other.bonked)
            other.enterTile(true);
        if (!other._internalIgnores(this)) {
            other.slidingState = SlidingState.WEAK;
            other.direction = this.level.randomForceFloorDirection++;
            this.level.randomForceFloorDirection %= 4;
            if (other.bonked) {
                if (other._internalStep(other.direction))
                    other.cooldown--;
            }
        }
    }
    speedMod() {
        return 2;
    }
}
ForceFloorRandom.tags = ["force-floor"];
actorDB["forceFloorRandom"] = ForceFloorRandom;
// random
export class RecessedWall extends Actor {
    constructor() {
        super(...arguments);
        this.id = "popupWall";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorLeft() {
        var _a;
        if (this.tile.hasLayer(Layer.MOVABLE))
            return;
        this.destroy(this, null);
        new Wall(this.level, this.tile.position);
        (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("recessed wall");
    }
}
RecessedWall.blockTags = ["cc1block", "normal-monster"];
actorDB["popupWall"] = RecessedWall;
export class Void extends Actor {
    constructor() {
        super(...arguments);
        this.id = "void";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorCompletelyJoined(other) {
        other.destroy(this, null);
    }
}
actorDB["void"] = Void;
export class Water extends Actor {
    constructor() {
        super(...arguments);
        this.id = "water";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorCompletelyJoinedIgnored(other) {
        var _a;
        if (other.hasTag("playable")) {
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("water step");
        }
    }
    actorCompletelyJoined(other) {
        other.destroy(this, "splash");
    }
}
Water.tags = ["water", "water-ish"];
actorDB["water"] = Water;
export class Dirt extends Actor {
    constructor() {
        super(...arguments);
        this.id = "dirt";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorCompletelyJoined() {
        var _a;
        (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("dirt clear");
        this.destroy(this, null);
    }
}
Dirt.tags = ["filth", "boot-removable"];
Dirt.blockTags = ["cc1block", "normal-monster", "melinda"];
actorDB["dirt"] = Dirt;
export class Gravel extends Actor {
    constructor() {
        super(...arguments);
        this.id = "gravel";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
}
Gravel.tags = ["filth"];
Gravel.blockTags = ["normal-monster", "melinda"];
actorDB["gravel"] = Gravel;
export class Exit extends Actor {
    constructor() {
        super(...arguments);
        this.id = "exit";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorCompletelyJoined(other) {
        var _a;
        if (other instanceof Playable) {
            const oldGameState = this.level.gameState;
            if (other === this.level.selectedPlayable)
                this.level.selectedPlayable =
                    this.level.playables[(this.level.playables.indexOf(other) + 1) %
                        this.level.playables.length];
            other.destroy(this, null);
            this.level.gameState = oldGameState;
            this.level.playablesLeft--;
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce(`win ${other.id}`);
            this.level.releasedKeys = { ...this.level.gameInput };
        }
    }
}
Exit.tags = ["exit"];
Exit.blockTags = ["normal-monster", "cc1block"];
actorDB["exit"] = Exit;
export class EChipGate extends Actor {
    constructor() {
        super(...arguments);
        this.id = "echipGate";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorCompletelyJoined(other) {
        var _a;
        if (this.level.chipsLeft === 0) {
            this.destroy(other, null);
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("socket unlock");
        }
    }
    blocks() {
        return this.level.chipsLeft !== 0;
    }
}
EChipGate.tags = ["echip-gate"];
EChipGate.immuneTags = ["tnt"];
EChipGate.blockTags = ["normal-monster", "cc1block"];
actorDB["echipGate"] = EChipGate;
export class Hint extends Actor {
    constructor(level, position, customData, direction) {
        super(level, position, customData, direction);
        this.id = "hint";
        if (this.level.hintsLeft.length > 0)
            this.hint = this.level.hintsLeft.shift();
        else
            this.hint = this.level.defaultHint;
    }
    getLayer() {
        return Layer.STATIONARY;
    }
}
Hint.blockTags = ["normal-monster", "cc1block"];
actorDB["hint"] = Hint;
export class Fire extends Actor {
    constructor() {
        super(...arguments);
        this.id = "fire";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorCompletelyJoinedIgnored(other) {
        var _a;
        if (other.hasTag("playable")) {
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("fire step");
        }
    }
    actorCompletelyJoined(other) {
        if (!other.hasTag("meltable-block"))
            other.destroy(this);
    }
}
Fire.tags = ["fire", "melting", "boot-removable"];
Fire.blockTags = ["autonomous-monster"];
actorDB["fire"] = Fire;
export class ThiefTool extends Actor {
    constructor() {
        super(...arguments);
        this.id = "thiefTool";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorCompletelyJoined(other) {
        var _a;
        if (!other.hasTag("real-playable"))
            return;
        for (const [key, item] of other.inventory.items.entries()) {
            if (item.hasTag("bribe")) {
                other.inventory.items.splice(key, 1);
                return;
            }
        }
        (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("robbed");
        other.inventory.items = [];
        other.recomputeTags();
        this.level.bonusPoints = Math.floor(this.level.bonusPoints / 2);
    }
}
ThiefTool.blockTags = ["normal-monster", "cc1block"];
actorDB["thiefTool"] = ThiefTool;
export class ThiefKey extends Actor {
    constructor() {
        super(...arguments);
        this.id = "thiefKey";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorCompletelyJoined(other) {
        var _a;
        if (!other.hasTag("real-playable"))
            return;
        for (const [key, item] of other.inventory.items.entries()) {
            if (item.hasTag("bribe")) {
                other.inventory.items.splice(key, 1);
                return;
            }
        }
        (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("robbed");
        other.inventory.keys = {};
        this.level.bonusPoints = Math.floor(this.level.bonusPoints / 2);
    }
}
ThiefKey.blockTags = ["normal-monster", "cc1block"];
actorDB["thiefKey"] = ThiefKey;
export class Trap extends Actor {
    constructor() {
        super(...arguments);
        this.id = "trap";
        this.openRequests = this.customData === "open" ? 1 : 0;
        this.openRequestAt = null;
        this.caresButtonColors = ["brown"];
        this.listensWires = true;
    }
    get isOpen() {
        if (this.openRequestAt === this.level.currentTick * 3 + this.level.subtick)
            return true;
        if (this.wired)
            return !!this.poweredWires;
        return this.openRequests > 0;
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    exitBlocks() {
        return !this.isOpen;
    }
    setFrozen(actor) {
        const frozen = !this.isOpen;
        if (!frozen) {
            actor.frozen = false;
            return;
        }
        if (actor.hasTag("overpowers-trap-sliding"))
            return;
        actor.frozen = true;
    }
    setFrozenAll() {
        if (this.tile[Layer.MOVABLE]) {
            this.setFrozen(this.tile[Layer.MOVABLE]);
        }
    }
    buttonPressed(_type, data) {
        const wasOpen = this.isOpen;
        if (this.customData === "open")
            this.customData = "";
        else
            this.openRequests++;
        this.openRequestAt = this.level.currentTick * 3 + this.level.subtick;
        if (data !== "init" && !wasOpen && this.isOpen) {
            const movable = this.tile[Layer.MOVABLE];
            if (movable) {
                this.setFrozen(movable);
                if (movable._internalStep(movable.direction))
                    movable.cooldown--;
            }
        }
    }
    buttonUnpressed() {
        this.openRequests = Math.max(0, this.openRequests - 1);
        this.setFrozenAll();
    }
    actorJoined(other) {
        this.setFrozen(other);
    }
    levelStarted() {
        this.setFrozenAll();
    }
    pulse(actual) {
        if (!actual)
            return;
        this.setFrozenAll();
    }
    unpulse() {
        this.setFrozenAll();
    }
}
actorDB["trap"] = Trap;
// onLevelDecisionTick.push(level => {
// 	for (const trap of level.actors) {
// 		if (trap.id !== "trap" || !trap.circuits || !(trap instanceof Trap))
// 			continue
// 		trap.isOpen = !!trap.poweredWires
// 		for (const movable of trap.tile[Layer.MOVABLE]) {
// 			trap.setFrozen(movable, !trap.isOpen)
// 		}
// 	}
// })
// TODO CC1 clone machines
export class CloneMachine extends Actor {
    constructor() {
        super(...arguments);
        this.id = "cloneMachine";
        this.isCloning = false;
        this.cloneArrows = this.customData === "cc1"
            ? []
            : Array.from(this.customData).map(val => "URDL".indexOf(val));
        this.caresButtonColors = ["red"];
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    // Allow actors to exit while cloning, so they can properly move out of the tile
    exitBlocks() {
        return !this.isCloning;
    }
    levelStarted() {
        const movable = this.tile[Layer.MOVABLE];
        if (movable) {
            movable.frozen = true;
        }
    }
    actorJoined(other) {
        other.frozen = true;
    }
    blocks(other) {
        return (!other.hasTag("interacts-with-closed-clone-machine") &&
            this.tile.hasLayer(Layer.MOVABLE));
    }
    tryMovingInto(clonee, direction) {
        return clonee.checkCollision(direction) && clonee._internalStep(direction);
    }
    // Cloning with rotation happens at the start of the tick (pre-wire tick), so the extra cooldown is not needed
    clone(attemptToRotate) {
        let clonee = this.tile[Layer.MOVABLE];
        if (!clonee)
            return;
        this.isCloning = true;
        if (clonee.cooldown) {
            this.isCloning = false;
            return;
        }
        clonee.frozen = false;
        clonee.slidingState = SlidingState.STRONG;
        if (this.tryMovingInto(clonee, clonee.direction)) {
            clonee.cooldown--;
        }
        else {
            if (clonee.newActor)
                clonee = clonee.newActor;
            const ogDir = clonee.direction;
            if (attemptToRotate) {
                for (let i = 1; i <= 3; i++) {
                    if (this.tryMovingInto(clonee, (ogDir + i) % 4)) {
                        clonee.cooldown--;
                        break;
                    }
                    if (clonee.newActor)
                        clonee = clonee.newActor;
                }
            }
            if (clonee.cooldown === 0) {
                clonee.direction = ogDir;
                clonee.frozen = true;
                clonee.slidingState = SlidingState.NONE;
                this.isCloning = false;
                return;
            }
        }
        const newClone = new actorDB[clonee.id](this.level, this.tile.position, clonee.customData);
        newClone.direction = clonee.direction;
        newClone.frozen = true;
        this.isCloning = false;
    }
    buttonPressed() {
        this.clone(false);
        return true;
    }
    pulse(actual) {
        this.clone(actual);
    }
}
CloneMachine.tags = ["machinery"];
// Always block boomer actors
CloneMachine.blockTags = ["cc1block", "normal-monster", "real-playable"];
actorDB["cloneMachine"] = CloneMachine;
export class Bomb extends Actor {
    constructor() {
        super(...arguments);
        this.id = "bomb";
    }
    getLayer() {
        return Layer.ITEM; // Yes
    }
    actorOnTile(other) {
        if (other.layer !== Layer.MOVABLE || other._internalIgnores(this))
            return;
        other.destroy(this);
        this.destroy(other, null);
    }
}
Bomb.tags = ["bomb"];
actorDB["bomb"] = Bomb;
export class Turtle extends Actor {
    constructor() {
        super(...arguments);
        this.id = "turtle";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorLeft() {
        if (this.tile.hasLayer(Layer.MOVABLE))
            return;
        this.destroy(null, "splash");
        new Water(this.level, this.tile.position);
    }
}
Turtle.tags = ["water-ish"];
Turtle.blockTags = ["melting"];
actorDB["turtle"] = Turtle;
export class GreenBomb extends Actor {
    constructor(level, position, customData, direction) {
        super(level, position, customData, direction);
        this.id = "greenBomb";
        level.chipsTotal++;
        level.chipsLeft++;
        level.chipsRequired++;
        if (customData === "echip") {
            this.tags |= getTagFlag("item");
        }
    }
    getLayer() {
        return Layer.ITEM; // Yes
    }
    actorCompletelyJoined(other) {
        var _a;
        if (this.customData === "bomb") {
            other.destroy(this, null);
            this.destroy(other);
        }
        else if (other.hasTag("real-playable")) {
            this.destroy(null, null);
            this.level.chipsLeft = Math.max(0, this.level.chipsLeft - 1);
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("item get");
        }
    }
    greenToggle() {
        this.customData = this.customData === "bomb" ? "echip" : "bomb";
        if (this.customData === "echip") {
            this.tags |= getTagFlag("item");
        }
        else {
            this.tags &= ~getTagFlag("item");
        }
    }
    blocks(other) {
        return (this.customData === "echip" &&
            !other.hasTag("can-pickup-items") &&
            !other.hasTag("can-stand-on-items") &&
            !other.hasTag("playable"));
    }
}
GreenBomb.tags = ["bomb"];
actorDB["greenBomb"] = GreenBomb;
export class Slime extends Actor {
    constructor() {
        super(...arguments);
        this.id = "slime";
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    actorCompletelyJoined(other) {
        if (other.hasTag("dies-in-slime") ||
            !(other.hasTag("block") || other.hasTag("clears-slime")))
            other.destroy(this, "splash");
        else
            this.destroy(null, null);
    }
}
Slime.tags = ["slime"];
actorDB["slime"] = Slime;
export class FlameJet extends Actor {
    getLayer() {
        return Layer.STATIONARY;
    }
    updateTags() {
        if (this.customData === "on") {
            this.tags |= getTagFlag("fire");
        }
        else {
            this.tags &= ~getTagFlag("fire");
        }
    }
    actorOnTile(other) {
        if (this.customData === "on" && other.layer === Layer.MOVABLE)
            other.destroy(this);
    }
    buttonPressed() {
        this.customData = this.customData === "on" ? "off" : "on";
        this.updateTags();
    }
    constructor(level, pos, customData) {
        super(level, pos, customData);
        this.id = "flameJet";
        this.caresButtonColors = ["orange"];
        this.buttonUnpressed = this.buttonPressed;
        this.pulse = this.buttonPressed;
        this.updateTags();
    }
}
FlameJet.tags = ["jet"];
FlameJet.immuneTags = ["meltable-block"];
actorDB["flameJet"] = FlameJet;
export const updateJetlife = (level) => {
    var _a, _b, _c;
    if (!((_b = (_a = level.levelData) === null || _a === void 0 ? void 0 : _a.customData) === null || _b === void 0 ? void 0 : _b.jetlife))
        return;
    if ((level.currentTick * 3 + level.subtick) %
        parseInt(level.levelData.customData.jetlife) !==
        0)
        return;
    const queuedUpdates = [];
    for (const actor of level.actors)
        if (actor instanceof FlameJet) {
            let neighbors = 0;
            for (let xOff = -1; xOff <= 1; xOff++)
                for (let yOff = -1; yOff <= 1; yOff++) {
                    const tile = (_c = level.field[actor.tile.x + xOff]) === null || _c === void 0 ? void 0 : _c[actor.tile.y + yOff];
                    if (tile && !(xOff === 0 && yOff === 0))
                        for (const actor of tile.allActors)
                            if (actor.hasTag("fire"))
                                neighbors++;
                }
            if (neighbors === 3)
                queuedUpdates.push([actor, "on"]);
            else if (neighbors !== 2)
                queuedUpdates.push([actor, "off"]);
        }
    for (const update of queuedUpdates) {
        update[0].customData = update[1];
        update[0].updateTags();
    }
};
onLevelDecisionTick.push(updateJetlife);
export class Transmogrifier extends Actor {
    constructor() {
        super(...arguments);
        this.id = "transmogrifier";
        this.wired = false;
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    isActive() {
        return !this.wired || !!this.poweredWires;
    }
    actorCompletelyJoined(other) {
        var _a;
        if (!this.isActive())
            return;
        let transmogValue;
        if (hasOwnProperty(other, "transmogrifierTarget"))
            if (typeof other.transmogrifierTarget === "string")
                transmogValue = other.transmogrifierTarget;
            else if (typeof other.transmogrifierTarget === "function")
                transmogValue = other.transmogrifierTarget();
        if (transmogValue) {
            other.replaceWith(actorDB[transmogValue]);
            (_a = this.level.sfxManager) === null || _a === void 0 ? void 0 : _a.playOnce("teleport");
        }
    }
}
actorDB["transmogrifier"] = Transmogrifier;
export const directionStrings = "URDL";
export class Railroad extends Actor {
    constructor() {
        super(...arguments);
        this.id = "railroad";
        this.isSwitch = this.customData.includes("s");
        this.allRRRedirects = ["UR", "DR", "DL", "UL", "LR", "UD"];
        this.activeTrack = this.allRRRedirects[parseInt(this.customData[0] || "0")];
        this.lastEnteredDirection = parseInt(this.customData[1] || "0");
        this.baseRedirects = Array.from(this.customData.substr(2))
            .filter(val => !isNaN(parseInt(val)))
            .map(val => this.allRRRedirects[parseInt(val)]);
    }
    get legalRedirects() {
        return this.isSwitch
            ? this.baseRedirects.includes(this.activeTrack)
                ? [this.activeTrack]
                : []
            : this.baseRedirects;
    }
    getLayer() {
        return Layer.STATIONARY;
    }
    blocks(_other, enterDirection) {
        const directionString = directionStrings[(enterDirection + 2) % 4];
        // If there is no legal redirect regarding this direction, this direction cannot be entered
        return !this.legalRedirects.find(val => val.includes(directionString));
    }
    actorCompletelyJoined(other) {
        this.lastEnteredDirection = other.direction;
    }
    redirectTileMemberDirection(other, direction) {
        if (other.hasTag("ignores-railroad-redirect"))
            return direction;
        const directionString = directionStrings[(this.lastEnteredDirection + 2) % 4];
        const legalRedirects = this.legalRedirects
            .filter(val => val.includes(directionString))
            .map(val => directionStrings.indexOf(val[1 - val.indexOf(directionString)]));
        if (other.hasTag("reverse-on-railroad"))
            legalRedirects.push((this.lastEnteredDirection + 2) % 4);
        // Search for a valid (relative) direction in this order: Forward, right, left, backward
        for (const offset of [0, 1, -1, 2])
            if (legalRedirects.includes((direction + offset + 4) % 4))
                return (direction + offset + 4) % 4;
        // This...shouldn't happen outside of illegal railroads or RR signs, so don't redirect
        return null;
    }
    actorLeft(other) {
        if (!this.isSwitch || this.wired)
            return;
        const enterDirection = directionStrings[(this.lastEnteredDirection + 2) % 4], 
        // Note that it doesn't have to make a move which makes sense, you just have to enter and exit in directions which are valid in a vacuum
        isLegalISH = !!this.legalRedirects.find(val => val.includes(enterDirection) &&
            val.includes(directionStrings[other.direction]));
        if (isLegalISH) {
            const exActiveTrack = this.allRRRedirects.indexOf(this.activeTrack);
            for (let redirectID = (exActiveTrack + 1) % 6; redirectID !== exActiveTrack; redirectID = (redirectID + 1) % 6)
                if (this.baseRedirects.includes(this.allRRRedirects[redirectID])) {
                    this.activeTrack = this.allRRRedirects[redirectID];
                    break;
                }
        }
    }
    pulse() {
        const exActiveTrack = this.allRRRedirects.indexOf(this.activeTrack);
        for (let redirectID = (exActiveTrack + 1) % 6; redirectID !== exActiveTrack; redirectID = (redirectID + 1) % 6)
            if (this.baseRedirects.includes(this.allRRRedirects[redirectID])) {
                this.activeTrack = this.allRRRedirects[redirectID];
                break;
            }
    }
}
Railroad.tags = ["railroad"];
actorDB["railroad"] = Railroad;
onLevelWireTick.push(level => {
    for (const logicGate of level.circuitInputs) {
        if (logicGate instanceof LogicGate) {
            logicGate.doTeleport();
        }
    }
});
export class LogicGate extends Actor {
    getLayer() {
        return Layer.STATIONARY;
    }
    constructor(level, position, customData, direction) {
        super(level, position, customData, direction);
        this.providesPower = true;
        this.wireOverlapMode = WireOverlapMode.NONE;
        this.heldActor = null;
        this.wires = this.getInputWires() | this.getOutputWires();
        // Shift bits with wrap
        this.wires =
            ((this.wires << this.direction) & 0b1111) |
                (this.wires >> (4 - this.direction));
    }
    updateWires() {
        const poweredWires = ((this.poweredWires << (4 - this.direction)) & 0b1111) |
            (this.poweredWires >> this.direction);
        this.poweringWires = this.processWires(poweredWires);
        this.poweringWires =
            ((this.poweringWires << this.direction) & 0b1111) |
                (this.poweringWires >> (4 - this.direction));
    }
    isBlueTeleportTarget() {
        return true;
    }
    takeTeleport(other) {
        other.exists = false;
        other.oldTile = other.tile;
        other.tile = this.tile;
        this.heldActor = other;
    }
    giveUpTeleport(other) {
        other.exists = true;
        this.heldActor = null;
    }
    doTeleport() {
        if (this.heldActor) {
            doBlueTeleport(this, this.heldActor);
        }
    }
    isBusy() {
        return (!!this.heldActor ||
            (dirToWire((wireToDir(this.getOutputWires()) + this.direction) % 4) &
                (this.poweredWires | this.poweringWires)) ===
                0);
    }
    getTeleportInputCircuit() {
        const circuits = [];
        for (let dir = Direction.UP; dir <= Direction.LEFT; dir++) {
            const wire = 1 << dir;
            if (this.getInputWires() & wire) {
                circuits.push(this.circuits[(dir + this.direction) % 4]);
            }
        }
        return circuits;
    }
    getTeleportOutputCircuit() {
        for (let dir = Direction.UP; dir <= Direction.LEFT; dir++) {
            const wire = 1 << dir;
            if (this.getOutputWires() & wire) {
                return this.circuits[(dir + this.direction) % 4];
            }
        }
    }
}
LogicGate.immuneTags = ["tnt"];
export class NotGate extends LogicGate {
    constructor() {
        super(...arguments);
        this.id = "notGate";
    }
    getInputWires() {
        return Wires.DOWN;
    }
    getOutputWires() {
        return Wires.UP;
    }
    processWires(wires) {
        if (!(wires & Wires.DOWN))
            return Wires.UP;
        return 0;
    }
}
actorDB["notGate"] = NotGate;
export class AndGate extends LogicGate {
    constructor() {
        super(...arguments);
        this.id = "andGate";
    }
    getInputWires() {
        return Wires.LEFT | Wires.RIGHT;
    }
    getOutputWires() {
        return Wires.UP;
    }
    processWires(wires) {
        if ((wires & (Wires.RIGHT | Wires.LEFT)) === (Wires.RIGHT | Wires.LEFT))
            return Wires.UP;
        return 0;
    }
}
actorDB["andGate"] = AndGate;
export class NandGate extends LogicGate {
    constructor() {
        super(...arguments);
        this.id = "nandGate";
    }
    getInputWires() {
        return Wires.LEFT | Wires.RIGHT;
    }
    getOutputWires() {
        return Wires.UP;
    }
    processWires(wires) {
        if ((wires & (Wires.RIGHT | Wires.LEFT)) !== (Wires.RIGHT | Wires.LEFT))
            return Wires.UP;
        return 0;
    }
}
actorDB["nandGate"] = NandGate;
export class OrGate extends LogicGate {
    constructor() {
        super(...arguments);
        this.id = "orGate";
    }
    getInputWires() {
        return Wires.LEFT | Wires.RIGHT;
    }
    getOutputWires() {
        return Wires.UP;
    }
    processWires(wires) {
        if ((wires & (Wires.RIGHT | Wires.LEFT)) !== 0)
            return Wires.UP;
        return 0;
    }
}
actorDB["orGate"] = OrGate;
export class XorGate extends LogicGate {
    constructor() {
        super(...arguments);
        this.id = "xorGate";
    }
    getInputWires() {
        return Wires.LEFT | Wires.RIGHT;
    }
    getOutputWires() {
        return Wires.UP;
    }
    processWires(wires) {
        if (!!(wires & Wires.RIGHT) !== !!(wires & Wires.LEFT))
            return Wires.UP;
        return 0;
    }
}
actorDB["xorGate"] = XorGate;
export class LatchGate extends LogicGate {
    constructor() {
        super(...arguments);
        this.id = "latchGate";
        this.memory = false;
    }
    getInputWires() {
        return Wires.LEFT | Wires.RIGHT;
    }
    getOutputWires() {
        return Wires.UP;
    }
    processWires(wires) {
        if (wires & Wires.RIGHT)
            this.memory = !!(wires & Wires.LEFT);
        return this.memory ? Wires.UP : 0;
    }
}
actorDB["latchGate"] = LatchGate;
export class LatchGateMirror extends LogicGate {
    constructor() {
        super(...arguments);
        this.id = "latchGateMirror";
        this.memory = false;
    }
    getInputWires() {
        return Wires.LEFT | Wires.RIGHT;
    }
    getOutputWires() {
        return Wires.UP;
    }
    processWires(wires) {
        if (wires & Wires.LEFT)
            this.memory = !!(wires & Wires.RIGHT);
        return this.memory ? Wires.UP : 0;
    }
}
actorDB["latchGateMirror"] = LatchGateMirror;
export class CounterGate extends LogicGate {
    constructor() {
        super(...arguments);
        this.id = "counterGate";
        this.memory = parseInt(this.customData || "0");
        this.underflowing = false;
        this.lastPowered = 0;
    }
    getInputWires() {
        return Wires.DOWN | Wires.LEFT;
    }
    getOutputWires() {
        return Wires.UP | Wires.RIGHT;
    }
    // This is kinda forgettable, but
    // Up - Underflow, Right - Increment, Down - Decrement, Left - Overflow
    processWires(wires) {
        const nextPowered = wires;
        wires &= ~this.lastPowered;
        this.lastPowered = nextPowered;
        if (wires & (Wires.RIGHT | Wires.DOWN)) {
            this.underflowing = false;
        }
        if ((wires & (Wires.RIGHT | Wires.DOWN)) === (Wires.RIGHT | Wires.DOWN))
            return 0;
        if (wires & Wires.RIGHT) {
            this.memory++;
            if (this.memory === 10) {
                this.memory = 0;
                return Wires.LEFT;
            }
        }
        if (wires & Wires.DOWN) {
            this.memory--;
            if (this.memory === -1) {
                this.memory = 9;
                this.underflowing = true;
            }
        }
        return this.underflowing ? Wires.UP : 0;
    }
    isBlueTeleportTarget() {
        return false;
    }
}
actorDB["counterGate"] = CounterGate;
//# sourceMappingURL=terrain.js.map